import { FC, useMemo } from 'react'
import EditoIntro, { EditoIntroProps } from 'src/components/EditoIntro'
import { RichTextTransformer } from 'src/relay/Transformers/RichTextTransformer'

import { BlockProps } from '../props'

import { IntroBlockProps } from './props'

const IntroBlock: FC<BlockProps<IntroBlockProps>> = ({
  data,
  configuration,
  locale,
}) => {
  const props: EditoIntroProps = useMemo(
    () => ({
      title: data.title || '',
      ...(data.content && {
        richTextProps: RichTextTransformer(data.content, configuration, locale),
      }),
      isSecondary: data.secondary,
    }),
    [configuration, data, locale]
  )

  return <EditoIntro {...props} />
}

export default IntroBlock
